var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "renwu-customer" }, [
    _c("div", { staticClass: "from-item" }, [
      _c("span", { staticClass: "from-lable" }, [_vm._v("替看人")]),
      _vm._v(" "),
      _c("div", { staticClass: "from-control" }, [
        _c("input", {
          attrs: { type: "text", placeholder: "请输入经纪人姓名" },
          domProps: { value: _vm.name },
          on: {
            input: function ($event) {
              return _vm.inputChange($event)
            },
          },
        }),
      ]),
    ]),
    _vm._v(" "),
    _vm.list.length > 0
      ? _c(
          "div",
          { staticClass: "list" },
          _vm._l(_vm.list, function (item) {
            return _c(
              "div",
              {
                key: item.id,
                staticClass: "item",
                on: {
                  click: function ($event) {
                    return _vm.select(item)
                  },
                },
              },
              [
                _c("span", { staticClass: "name" }, [
                  _vm._v(_vm._s(item.login_name)),
                ]),
              ]
            )
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "btn-commit", on: { click: _vm.commit } }, [
      _vm._v("确认"),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }